import measurePerformance from "@/core/measurePerformance"
import { wrapAsync } from "@/utils/wrapAsync"
import { injectCustomCampaign } from "./injection"

/**
 * Injects custom campaigns into specified target elements.
 *
 * @param campaigns - A record of campaign IDs and their HTML content.
 * @param targets - A record of campaign IDs and their corresponding HTML elements.
 * @remarks This function is used to inject custom campaigns into specific elements on the page.
 */
export function injectCampaigns(campaigns: Record<string, string>, targets?: Record<string, HTMLElement>) {
  if (!targets) {
    return Promise.resolve([])
  }
  return measurePerformance("nosto.inject_custom_campaigns", () => {
    return Promise.all(
      Object.keys(campaigns)
        .map(key => {
          const value = campaigns[key]
          // noinspection TypeScriptValidateTypes
          const div = targets[key]
          if (div) {
            return wrapAsync<[string, HTMLElement[]]>(() => {
              injectCustomCampaign(div, value)
              // NOTE: no effects.show here, as this is a custom placement
              return [key, [div]]
            })
          }
          return undefined
        })
        .filter(Boolean)
    )
  })
}
